import React, { useEffect, useState, useMemo, useContext } from "react";
import { useHistory } from "react-router";
import {
  TextField,
  Button,
  Modal,
  Backdrop,
  Fade,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateIcon from "@mui/icons-material/Create";
import AddIcon from "@mui/icons-material/Add";

import DataTable from "react-data-table-component";
import Toast from "../../utils/Toast";

import Loader from "../../components/Loader";
import useUsers from "../../queries/user/getUsers";
import useDeleteUser from "../../mutation/user/deleteUser";
import { AuthContext } from "../../utils/userProvider";
import {
  ListPageShell,
  ListPageCard,
  ListPageHeader,
  dataTableCustomStyles,
  modalSx,
  DeleteModalFrame,
} from "../../components/ListPage";

const Users = () => {
  const history = useHistory();
  const [promotionTable, setPromotionTable] = useState([]);
  const { authState, setAuthState } = useContext(AuthContext);
  // const [transactionTable, setTransactionTable] = useState([]);
  const [deleteResponse, setDeleteData] = useDeleteUser();

  const [openDeleteUser, setOpenDeleteUser] = useState(false);
  const [deleteRow, setDeleteRow] = useState();

  let columns = [
    {
      name: "Email",
      selector: "email",
      sortable: true,
    },
    {
      name: "Role",
      selector: "role",
      sortable: true,
      cell: (row, index, column, id) => {
        return <span>{row.accessRole}</span>;
      },
    },
    {
      name: "First Login?",
      selector: "firstLogin",
      sortable: true,
      cell: (row, index, column, id) => {
        return <span>{!row.firstLogin ? "Yes" : "No"}</span>;
      },
    },
    {
      name: "Super Admin",
      selector: "SuperAdmin",
      cell: (row, index, column, id) => {
        return <span>{row.SuperAdmin}</span>;
      },
    },
    {
      name: "Manager",
      selector: "Manager",
      cell: (row, index, column, id) => {
        return <span>{row.Manager}</span>;
      },
    },
    {
      name: "Options",
      cell: (row, index, column, id) => {
        if (!row.archived) {
          return (
            <div>
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<CreateIcon />}
                onClick={() => {
                  editItem(row);
                }}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<DeleteIcon />}
                onClick={() => {
                  deleteItem(row);
                }}
              >
                Delete
              </Button>
            </div>
          );
        } else {
          return null;
        }
      },
    },
  ];

  const [userResponse, resetUser] = useUsers();

  const [filterText, setFilterText] = useState("");

  const handleFilterText = (event) => {
    setFilterText(event.target.value);
  };

  const filteredItems = promotionTable.filter(
    (item) =>
      item.accessRole &&
      item.accessRole != "SuperAdmin" &&
      item.id != authState.userId &&
      !(authState.role == "Manager" && item.accessRole == "Manager") &&
      ((item.username &&
        item.username.toLowerCase().includes(filterText.toLowerCase())) ||
        item.email?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.accessRole?.toLowerCase().includes(filterText.toLowerCase()))
  );

  const updateTableData = (data) => {
    let newTableData = [...promotionTable];
    if (data != null) {
      let index = newTableData.findIndex((object) => object.id == data.id);
      newTableData[index] = data;
      setPromotionTable(newTableData);
    } else {
      setPromotionTable(newTableData);
    }
  };

  useEffect(() => {
    if (userResponse.data) {
      let responseData = userResponse.data;
      for (var i = 0; i < responseData.length; i++) {
        if (responseData[i].SuperAdmin) {
          let superAdmin = responseData.find(
            (ele) => responseData[i].SuperAdmin == ele.id
          );
          if (superAdmin) {
            responseData[i].SuperAdmin = superAdmin.email;
          }
        }
        if (responseData[i].Manager) {
          let manager = responseData.find(
            (ele) => responseData[i].Manager == ele.id
          );
          if (manager) {
            responseData[i].Manager = manager.email;
          }
        }
      }
      console.log(responseData);
      setPromotionTable([...responseData]);
    }
  }, [userResponse]);

  useEffect(() => {
    if (authState.role == "Executive") {
      history.push("/dashboard/roomtypes");
    }
  }, [authState]);

  const editItem = (row) => {
    window.location.href = "/dashboard/users/edit/" + row.id;
  };

  const deleteItem = (row) => {
    setDeleteRow(row);
    setOpenDeleteUser(true);
  };

  const handleClose = () => {
    setOpenDeleteUser(false);
  };

  const confirmDelete = () => {
    setDeleteData({
      id: deleteRow.id,
    });
  };

  useEffect(() => {
    if (deleteResponse.data) {
      Toast.fire({
        icon: "success",
        title: "User deleted",
      });
      setDeleteRow(null);
      setOpenDeleteUser(false);
      resetUser();
    } else if (deleteResponse.error) {
      Toast.fire({
        icon: "error",
        text: "An Error has occured. Please try again.",
      });
      setDeleteRow(null);
      setOpenDeleteUser(false);
    }
  }, [deleteResponse]);

  const newUser = () => {
    window.location.href = "/dashboard/users/new";
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={newUser}
        >
          New User
        </Button>
        <TextField
          id="filter-text"
          onChange={handleFilterText}
          label="Search"
          variant="outlined"
          size="small"
        />
      </div>
    );
  }, [filterText]);

  return (
    <ListPageShell>
      <ListPageCard>
        {userResponse.loading && <Loader />}
        {!userResponse.loading && (
          <div>
            <ListPageHeader title="Users" />
            <DataTable
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10]}
              noHeader={true}
              subHeader
              data={filteredItems}
              columns={columns}
              subHeaderComponent={subHeaderComponentMemo}
              customStyles={dataTableCustomStyles}
            />
          </div>
        )}
      </ListPageCard>
      <Modal
        aria-labelledby="delete-modal"
        aria-describedby="delete-modal-description"
        sx={modalSx}
        open={openDeleteUser}
        onClose={(event, reason) => {
          if (reason === "backdropClick" && deleteResponse.loading) return;
          handleClose();
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
        disableEnforceFocus={true}
      >
        <Fade in={openDeleteUser}>
          <Box>
            <DeleteModalFrame title="Delete User">
              {deleteRow && (
                <div>
                  <p id="delete-modal-description">
                    Are you sure you want to delete{" "}
                    <b>
                      <u>{deleteRow.email}</u>
                    </b>
                    ?
                  </p>
                  <p>
                    This action cannot be{" "}
                    <b>
                      <u>reversed</u>
                    </b>
                    .
                  </p>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      mt: 5,
                      gap: 1,
                    }}
                  >
                    <Button
                      onClick={confirmDelete}
                      variant="contained"
                      color="primary"
                      disabled={deleteResponse.loading}
                    >
                      Confirm
                    </Button>
                    <Button
                      onClick={handleClose}
                      variant="contained"
                      color="secondary"
                      disabled={deleteResponse.loading}
                    >
                      Cancel
                    </Button>
                  </Box>
                </div>
              )}
            </DeleteModalFrame>
          </Box>
        </Fade>
      </Modal>
    </ListPageShell>
  );
};

export default Users;
